var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('r-score'),_vm._v(" "),_c('r-oil'),_vm._v(" "),_c('r-smooth'),_vm._v(" "),_c('r-darkcircle'),_vm._v(" "),_c('r-pimple'),_vm._v(" "),_c('r-blackhead'),_vm._v(" "),_c('img',{staticClass:"sr-a__link",attrs:{"src":require("./imgs/link.jpg"),"alt":"点击体验"},on:{"click":_vm.sendLog}}),_vm._v(" "),_c('r-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e43b77a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result/index.vue
// module id = null
// module chunks = 